import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
//@ts-ignore
import TrelloModel from 'app/scripts/models/internal/trello-model';

//@ts-ignore
class BoardPlugin extends TrelloModel {
  static initClass() {
    // @ts-ignore
    this.prototype.typeName = 'BoardPlugin';
  }

  isButler(): boolean {
    return this.get('idPlugin') === BUTLER_POWER_UP_ID;
  }
}
BoardPlugin.initClass();

export { BoardPlugin };
